module.exports = __webpack_public_path__ + "site/img/28.68a3b80d.jpg";